module.exports = __webpack_public_path__ + "img/lg_ring_skip_skip_null_0@2x.e26eb509.png";